// extracted by mini-css-extract-plugin
module.exports = {"skillSection":"_2lIfkCPZ7pPcl2lgxovfHm"};